export const LIMIT_FIELDS = Object.freeze([
  'minHeatSetpointLimit',
  'maxHeatSetpointLimit',
  'minCoolSetpointLimit',
  'maxCoolSetpointLimit',
] as const);
export type LimitField = (typeof LIMIT_FIELDS)[number];
export type LimitValues = Readonly<Record<LimitField, number>>;
export type NumericInterval = Readonly<{
  lower: number;
  upper: number;
  lowerInclusive: boolean;
  upperInclusive: boolean;
}>;
export type LimitMetricSpec = Readonly<{
  value?: string;
  units?: string;
  unit?: string;
  valueType?: string;
  valueStep?: number;
  defaultValue?: unknown;
  readOnly?: boolean;
}>;
export type LimitDomain = Readonly<{
  interval: NumericInterval;
  step?: number;
  defaultValue?: number;
}>;
export type LimitDomains = Readonly<Record<LimitField, LimitDomain>>;
export type LimitIssue = Readonly<{
  code: string;
  field?: LimitField;
  message: string;
}>;
export type LimitResult<T> =
  | { ok: true; value: T }
  | { ok: false; issues: readonly LimitIssue[] };
